module.exports = __webpack_public_path__ + "img/folder-blank.852df10b.svg";